export default __webpack_public_path__ + "static/media/Primers-_-Stucco.cbab4af2.jpg";